import React, { useState, useEffect } from "react";
import ImageLightbox from "react-image-lightbox";

function LightBox({
	images,
	isOpen,
	initialIndex = 0,
	onCloseRequest = () => {},
}) {
	const [photoIndex, setPhotoIndex] = useState(initialIndex);
	useEffect(() => {
		setPhotoIndex(initialIndex);
	}, [initialIndex]);
	return isOpen && images[photoIndex] ? (
		<ImageLightbox
			mainSrc={images[photoIndex]}
			nextSrc={images[(photoIndex + 1) % images.length]}
			prevSrc={images[(photoIndex + images.length - 1) % images.length]}
			onCloseRequest={onCloseRequest}
			onMovePrevRequest={() =>
				setPhotoIndex((photoIndex + images.length - 1) % images.length)
			}
			onMoveNextRequest={() => setPhotoIndex((photoIndex + 1) % images.length)}
		/>
	) : null;
}

function Image({ url, imageIndex, imageCount, onClick = () => {} }) {
	if (imageIndex >= 5) {
		throw new Error(
			"PhotoGallery: Only up to 5 images can be visually displayed."
		);
	}
	const shouldOverlayLastImage = imageIndex === 4;
	const setNumber = imageCount < 5 ? imageCount - 1 : 4;
	const imageClassSet = [
		[""],
		["", ""],
		[
			"row-span-2 col-span-1",
			"row-span-1 col-span-1",
			"row-span-1 col-span-1 col-start-2 ",
		],
		[
			"row-span-3 col-span-1",
			"row-span-1 col-span-1",
			"row-span-1 col-span-1 col-start-2",
			"row-span-1 col-span-1 col-start-2",
		],
		[
			"col-start-1 row-span-3 col-span-1",
			"col-start-2 row-span-2 col-span-1",
			"col-start-2 row-span-2 col-span-1",
			"col-start-1 row-span-3 col-span-1",
			"col-start-2 row-span-2 col-span-1",
		],
	];
	return shouldOverlayLastImage ? (
		<div
			className={`relative cursor-pointer  ${imageClassSet[setNumber][imageIndex]}`}
			onClick={() => onClick(imageIndex)}
		>
			<img src={url} className={`object-cover h-full w-full`} />
			<div className="bg-black text-white text-base font-bold absolute inset-0 opacity-70 flex items-center justify-center">
				{imageCount - 5} +
			</div>
		</div>
	) : (
		<img
			onClick={() => onClick(imageIndex)}
			src={url}
			className={`${imageClassSet[setNumber][imageIndex]} cursor-pointer object-cover h-full w-full`}
		/>
	);
}

function PhotoGrid({ images = [], onClick = () => {} }) {
	const imageCount = images.length;
	const colCountClass = imageCount <= 1 ? "grid-cols-1" : "grid-cols-2";
	const rowCountClass =
		imageCount <= 2
			? "grid-rows-1"
			: imageCount === 3
			? "grid-rows-2"
			: imageCount === 4
			? "grid-rows-3"
			: "grid-rows-6";
	return (
		<div
			style={{ maxHeight: "calc(100vh/1.25)" }}
			className={`grid gap-1 ${colCountClass} ${rowCountClass}`}
		>
			{images.slice(0, 5).map((url, idx) => (
				<Image
					key={url}
					url={url}
					imageIndex={idx}
					imageCount={imageCount}
					onClick={onClick}
				/>
			))}
		</div>
	);
}
export default function PhotoGallery({ images = [] }) {
	const [isOpen, setIsOpen] = useState(false);
	const [showImageIndex, setShowImageIndex] = useState(0);

	return images && images.length ? (
		<div className="PhotoGallery">
			<PhotoGrid
				images={images}
				onClick={(imgIndex) => {
					setShowImageIndex(imgIndex);
					setIsOpen(true);
				}}
			/>
			<LightBox
				images={images}
				isOpen={isOpen}
				initialIndex={showImageIndex}
				onCloseRequest={() => setIsOpen(false)}
			/>
		</div>
	) : null;
}
